import React from "react";
import { Navigate } from "react-router-dom";
import { getAdminToken } from "@/api/adminOneClient";

export default function AdminProtectedRoute({ children }) {
  const tok = getAdminToken();
  if (!tok) return <Navigate to="/adminone/login" replace />;
  return children;
}
